export const sectorsMixin = {
  data() {
    return {
      activeSector: {}
    };
  },
  computed: {
    isAquacultureActive() {
      return this.activeSector.name === this.sectors.aquaculture.name;
    },
    isEnergyActive() {
      return this.activeSector.name === this.sectors.energy.name;
    }
  }
};
